import 'regenerator-runtime/runtime';

import Referrals from './referrals/index';
import Entity from '../entity/entity';

window.$ = window.jQuery;

class Portal extends Entity {
  constructor() {
    super(null);
    this.global = this;

    this.referrals = new Referrals(this);
  }
}

window.portalHandler = new Portal();
